import { Component, OnDestroy, OnInit, TemplateRef, ViewChild, ViewEncapsulation,Injectable, EventEmitter,Output } from '@angular/core';
import {FormBuilder, FormGroup, Validators,FormControl} from '@angular/forms';
import { MatDialog, MatDialogRef} from '@angular/material/dialog';
import { DataSource } from '@angular/cdk/collections';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';
import { MatInput } from '@angular/material/input';
import {MatMenuTrigger} from '@angular/material/menu';

import { fuseAnimations } from '@fuse/animations';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';

import { MatSnackBar } from "@angular/material/snack-bar";

///IDIOMAS
import { lang_perfiles } from 'app/idiomas/i18n/perfiles/perfiles.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';

//SERVICE
import { RegisterService } from "../services/registeruser.service";
import {TranslateService} from '@ngx-translate/core';
import { ODSService } from "../services/ods.service";
import { AuthService } from 'app/auth/auth.service';
import * as backInter from 'app/auth/auth-data.model';
import Swal from 'sweetalert2';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import { institutos } from '../../../../../idiomas/i18n/perfiles/catalogos/en';

@Component({
  selector     : 'registeruser',
  templateUrl  : './registeruser.component.html',
  styleUrls    : ['./registeruser.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations : fuseAnimations
})
export class RegisterUserComponent implements OnInit {

  formUserRegister: FormGroup;

  levels: any;

  enterprises: any;
  institutes : any;
  institutoId: number;
  nivelUsuario: number;
  buscarEmpresa:string;

  busqueda: string = "";
  selectedEnterpriseBusU: string = "";
  busquedaUsuario: string = "";
  respuesta: string = "";
  respuestagptw= "";
  searchUserCompany= "";
  paginaActual: number;
  totalEmpresas: number;
  nextPag: number;
  prevPag: number;
  contadorInicio: number;
  contadorFin: number;


  paginaActualEmpresaGPTW: number;
  totalEmpresasEmpresaGPTW: number;
  nextPagEmpresaGPTW: number;
  prevPagEmpresaGPTW: number;
  contadorInicioEmpresaGPTW: number;
  contadorFinEmpresaGPTW: number;
  cargando:boolean;
  tipoAccion:number=1;
  // displayedColumns: string[] = ['name','tipoen','numcol','totalco','totalfa','totalfin','acciones'];
  // dataSource: MatTableDataSource<backInter.encuestasActivas>;
  displayedColumns: string[] = ['nomemp', 'correo', 'tipousu', 'accion'];
  displayedColumnsGptwEmpresas: string[] = ['correo', 'accion'];
  displayedColumnsGptwyItbmEmpresas: string[] = ['correo','instituto','tipousu','accion'];
  dataSource: MatTableDataSource<any>;
  dataSourceEmpresaGPTW: any;
  nombreEmpresa:string;
  tipoUsuario:any;
  arregloTipoUsuario: any[]=[];

  selectVersion=[
    {
      id: "1",
      nombre: "Versión 3.1",
    },{
      id: "2",
      nombre: "Versión 3.2",
    },
    {
      id: "3",
      nombre: "Versión 3.3",
    }
  ];

idEmpresaBuscar:any;
nombreEmpresaBuscar:any;
usuariosEncontrados:boolean=true;
hide = true;

medirPassRegis:number=0;
longitudPassRegis:boolean=false;
regalasPassRegis:any[]=[
  {
    'regla': 'longitud',
     'estatus': false,
},
  {
    'regla': 'letraMin',
     'estatus': false,
},
  {
    'regla': 'letraMayu',
     'estatus': false,
},
  {
    'regla': 'numeroPass',
     'estatus': false,
},
  {
    'regla': 'caracterPass',
     'estatus': false,
},
]
letraMinPassRegis:boolean=false;
letraMayuPassRegis:boolean=false;
numePassRegis:boolean=false;
caracterPassRegis:boolean=false;
arregloReglasCumplidasRegis:any[]=[];
styleElementRegis: HTMLStyleElement;
passwordOkRegis:boolean=false;
idiomaNativo:any;
versTextLevelResultV2='';
versDisabledTextLevelResultV2:boolean=true;
preFilterPlat:any[]=[{"datosEmpresa.platform": 1},{"datosEmpresa.platform": 2},{"datosEmpresa.platform": 3}];
@ViewChild('idPassword', { read: MatInput }) input: MatInput;
@ViewChild('idUser', { read: MatInput }) inputUsers: MatInput;
@ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  constructor(private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private _formBuilder: FormBuilder,private registerService: RegisterService,
    private router: Router, public snackBar: MatSnackBar,
    private odsService: ODSService,
    private authService:AuthService,
    private translateSrv: TranslateService,
    public dialog: MatDialog,) {

      lang_perfiles.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });

      let infoUsu: backInter.infoUsuario = this.authService.getInfoUsuario();

      this.nivelUsuario = infoUsu.level;
      console.log("instituto Id:", infoUsu.institutoId );

      console.log("nivel Izzi: ",this.nivelUsuario );
      this.buscarEmpresa="";
      console.log(infoUsu);
      if(infoUsu.level == 3){
        this.institutoId = 0;
        console.log("hola chempo: ",this.institutoId);
      }
      else{
        this.institutoId = infoUsu.institutoId;
        console.log("hola chempo: ",this.institutoId);

      }
      localStorage.setItem('Idinstituto',this.institutoId.toString());
      this.idiomaNativo=this.translateSrv.currentLang;

    }

    ngOnInit() {
    this.styleElementRegis = document.createElement('style');
    this.formUserRegister = this._formBuilder.group({
        emailRegister: ['', Validators.required],
        passwordUser: ['', Validators.required],
        selectLevel: ['', Validators.required],
        selectEnterprise: ['0', Validators.required],
        search:['0'],
        instituto: [''],
        userName: ['', Validators.required],
        versLevelResultV2: [''],
        versDefaultLevelResultV2: ['1'],
      });
      // setTimeout(() => {
      //   this.clearInputMethod2();
      //   // this.logoCGO5 = false;
      // }, 1000);



      this.getLevelArray();
      // this.getEnterprisesArray();
      this.getInstituteArray();
      this.getListaEmpresas(1,1);
      this.getUsuariosEmpresasGptw(1);
     console.log(this.usuariosEncontrados);
     //
     // this.formUserRegister.controls['emailRegister'].setValue('');
     // this.formUserRegister.controls['passwordUser'].setValue('');
     setTimeout(() => {
       this.input.value = '';
       this.inputUsers.value = '';
     }, 800);

    }


// clearInputMethod1(){
//   console.log("si la mando a llamar");
//    this.emailRegister.reset();
//    this.passwordUser.reset();
//
//  }

// clearInputMethod2() {
// console.log("si la mando a llamar");
//   this.formUserRegister.setValue({emailRegister: '', passwordUser: ''});
// }
    public getInstituteArray() {
      this.odsService.getInstituteArray()
      .subscribe(response => {
        console.log(response);
        let result: Institute[] = response['Institutos'];
        this.institutes = result;
        this.validarInstitutos();

      }, error => {
        console.log("error", error);
      })
    }

  cambiarVersion(value){
  if (value==2) {
    this.versDisabledTextLevelResultV2=false;
  }else{
    this.versDisabledTextLevelResultV2=true;
  }

  }
    validarInstitutos(){

      if(this.nivelUsuario == 2 || this.nivelUsuario == 11 ){
        let institutoCorrecto: any[] = [];
        /*if(this.institutoId != 3){    //si el instituto no es china se quita el nivel 5, resultados segmentados
          nivelesPermitidosGPTW.splice(2,1);
        }*/
        this.institutes.forEach( (instituto) => {
          if(instituto.numInstituto == this.institutoId ){
            institutoCorrecto.push(instituto);
          }
        });
        console.log(institutoCorrecto);
        this.institutes=institutoCorrecto;

      }

    }


    openSnackBar(message: string, action: string) {
      Swal.fire({
        icon: 'error',
        title: message,
        confirmButtonText: action,
        confirmButtonColor: '#e40601'
      });
    }


    openSuccessSnackBar(message: string, action: string) {
      Swal.fire({
        icon: 'success',
        title: message,
        confirmButtonText: action,
        confirmButtonColor: '#e40601'
      });
    }
    //ENVIO DE FORMULARIO A REGISTRO DE USUARIO
    public registerUser(){
      //console.log(this.isValid(this.formUserRegister.value.emailRegister));
      //alert('hola');

      let user = this.formUserRegister.value.emailRegister;
      let pass = this.formUserRegister.value.passwordUser;
      let level = this.formUserRegister.value.selectLevel;
      let defaultVersResult = this.versDisabledTextLevelResultV2;
      let textVersResult = this.formUserRegister.value.versLevelResultV2;

      if (level!=17) {
        this.formUserRegister.controls["userName"].setValue('demo');
        if (level==3) {
          this.formUserRegister.value.instituto='0';
        }
        let enterprise = this.formUserRegister.value.selectEnterprise;
        let numInsti=this.formUserRegister.value.instituto;

        console.log("datos:",this.formUserRegister.value);
        console.log("datos numInsti:",numInsti);
        // this.formUserRegister.controls['userName'].value="demo";
        console.log('this.formUserRegister',this.formUserRegister);

        if (this.formUserRegister.valid) {
          if(this.isValid(user)){
            let passValida = this.validaPassSegura();
            console.log("passValida:",passValida);
            if(passValida){
              if(level == 1 || level == 5 || level == 8 || level == 4 || level == 10 || level == 12 || level == 13 || level == 14 || level == 18){
                if(enterprise == 0){
                  //console.log('Por favor, elija una empresa');
                  this.translateSrv.get('PERFILES.USUARIO.MSJ_SELECTCOMPANY').subscribe((res: string) => {
                    this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                  });
                }else{

                  //console.log('true');
                  this.registerService.registerUser(user,pass,level,enterprise,null,defaultVersResult,textVersResult).subscribe(response => {
                    //console.log(response['message']);
                    if(response['message'] == 'Success'){
                      this.translateSrv.get('PERFILES.USUARIO.REGISTER_SUCCESS').subscribe((res: string) => {
                        this.openSuccessSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                      });
                      this.router.navigate(['/profile-creator']);
                    }else{
                      this.translateSrv.get('PERFILES.USUARIO.REGISTER_ERROR').subscribe((res: string) => {
                        this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                      });
                    }
                  }, error => {
                    //console.log(error);
                  })
                }

              }else if(level == 9){


              }else if (level==19) {
                console.log('defaultVersResult',defaultVersResult);
                console.log('textVersResult',textVersResult);
                if (defaultVersResult==false) { //Cuando no es la versio por default
                  if (textVersResult=="") {
                    this.translateSrv.get('CONSULTATABLA.TEX_MOD_RESULT_VERS').subscribe((res: string) => {
                        this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                      });
                  }else{
                    if(enterprise == 0){
                        //console.log('Por favor, elija una empresa');
                        this.translateSrv.get('PERFILES.USUARIO.MSJ_SELECTCOMPANY').subscribe((res: string) => {
                            this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                          });
                        }else{
                            console.log('ya todo esta completo');
                            this.registerService.registerUser(user,pass,level,enterprise,null,defaultVersResult,textVersResult).subscribe(response => {
                                //console.log(response['message']);
                                if(response['message'] == 'Success'){
                                    this.translateSrv.get('PERFILES.USUARIO.REGISTER_SUCCESS').subscribe((res: string) => {
                                        this.openSuccessSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                                      });
                                      this.router.navigate(['/profile-creator']);
                                    }else{
                                        this.translateSrv.get('PERFILES.USUARIO.REGISTER_ERROR').subscribe((res: string) => {
                                            this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                                          });
                                        }
                                      }, error => {
                                          //console.log(error);
                                        })
                                      }
                  }
                }else{
                  if(enterprise == 0){
                      //console.log('Por favor, elija una empresa');
                      this.translateSrv.get('PERFILES.USUARIO.MSJ_SELECTCOMPANY').subscribe((res: string) => {
                          this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                        });
                      }else{
                        textVersResult="";
                          //console.log('true');
                          this.registerService.registerUser(user,pass,level,enterprise,null,defaultVersResult,textVersResult).subscribe(response => {
                              //console.log(response['message']);
                              if(response['message'] == 'Success'){
                                  this.translateSrv.get('PERFILES.USUARIO.REGISTER_SUCCESS').subscribe((res: string) => {
                                      this.openSuccessSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                                    });
                                    this.router.navigate(['/profile-creator']);
                                  }else{
                                      this.translateSrv.get('PERFILES.USUARIO.REGISTER_ERROR').subscribe((res: string) => {
                                          this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                                        });
                                      }
                                    }, error => {
                                        //console.log(error);
                                      })
                                    }

                }

              }else{
                let intitutoenviar: number;
                switch(level){
                  case 2: intitutoenviar = numInsti; break;
                  case 11: intitutoenviar = numInsti; break;
                  case 3: intitutoenviar = 0; break;
                }
                //console.log('true2');

                this.registerService.registerUser(user,pass,level,'0',intitutoenviar,defaultVersResult,textVersResult).subscribe(response => {
                  if(response['message'] == 'Success'){
                    this.translateSrv.get('PERFILES.USUARIO.REGISTER_SUCCESS').subscribe((res: string) => {
                      this.openSuccessSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                    });
                    this.router.navigate(['/profile-creator']);
                  }else{
                    this.translateSrv.get('PERFILES.USUARIO.REGISTER_ERROR').subscribe((res: string) => {
                      this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                    });
                  }
                }, error => {
                  console.log(error);
                })
              }
            }
          }else{
            //console.log('Por favor ingrese un Email valido.');
            this.translateSrv.get('PERFILES.USUARIO.MSJ_INVALIDEMAIL').subscribe((res: string) => {
              this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
            });
          }

        }else{
          this.translateSrv.get('PERFILES.USUARIO.MJS_COMPLETE_INFO').subscribe((res: string) => {
            this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
          });

        }
      }else{
        if (this.formUserRegister.valid) {
          if(this.isValid(user)){
            let passValida = this.validaPassSegura();
            console.log("passValida:",passValida);
            if(passValida){
              this.modalGuardado(1);
              console.log('Validado');
              let datos:any={
                email: user,
                password: pass,
                name: this.formUserRegister.value.userName,
                broker: 0,
                lang: this.idiomaNativo,
                level: 3,
                main_register: 1
              }
              this.registerService.saveUserAdminSwift(datos).subscribe((respuesta:any) => {
                console.log('respuesta',respuesta);
                if (respuesta.success) {
                  Swal.close();
                  this.translateSrv.get('PERFILES.USUARIO.REGISTER_SUCCESS_SWIFT').subscribe((res: string) => {
                    this.openSuccessSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                  });
                  this.router.navigate(['/profile-creator']);
                }else{
                  this.translateSrv.get('PERFILES.USUARIO.REGISTER_ERROR').subscribe((res: string) => {
                    this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
                  });
                }

              }, error => {
                //console.log(error);
              })

            }

          }else{
            //console.log('Por favor ingrese un Email valido.');
            this.translateSrv.get('PERFILES.USUARIO.MSJ_INVALIDEMAIL').subscribe((res: string) => {
              this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
            });
          }
        }
      }
    }

    modalGuardado(tipo:number){
      let mensajeModal:string;
      switch (tipo) {
        case 1:
       mensajeModal='PERFILES.USUARIO.MOD_SAV_US';
          break;
        default:
          break;
      }
      this.translateSrv.get(mensajeModal).subscribe((res: string) => { mensajeModal = res; });
      Swal.fire({
        title: mensajeModal,
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading()
        }
      });
    }
    validaPassSegura(){
      let status = false;
      let passActual = this.formUserRegister.controls['passwordUser'].value;
      let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
      let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
      let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
      let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
      let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
      console.log("passActual:",passActual);
      if(passActual.length > 7){
        if(regexMin.test(passActual)){
          if(regexMay.test(passActual)){
            if(regexNum.test(passActual)){
              if(regexCharEsp.test(passActual)){
                if(regexPass.test(passActual)){
                  status = true;
                } else{
                  //no pasó la validacion completa
                  console.log("no pasó la validacion completa");
                  this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.VALIDACION'),this.translateSrv.instant('ALERTS.OK'));
                }
              } else{
                //sin caracteres especiales
                console.log("sin caracteres especiales");
                this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.ESPCHARS'),this.translateSrv.instant('ALERTS.OK'));
              }
            } else{
              //sin numeros
              console.log("sin numeros");
              this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.NUMEROS'),this.translateSrv.instant('ALERTS.OK'));
            }
          } else{
            //sin mayusculas
            console.log("sin mayusculas");
            this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.MAYUSCULAS'),this.translateSrv.instant('ALERTS.OK'));
          }
        } else{
          //modal sin minusculas
          console.log("modal sin minusculas");
          this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.MINUSCULAS'),this.translateSrv.instant('ALERTS.OK'));
        }
      } else{
        console.log("longitud minima");
        this.openSnackBar(this.translateSrv.instant('ALERTS.PASSWORD.LONGITUD'),this.translateSrv.instant('ALERTS.OK'));
      }
      return status;
    }

    public isValid(email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }

    public getLevelArray() {
      this.registerService.getLevel().subscribe((response:any) => {
        console.log("Niveles");
        console.log(response);
        let result: Level[] = response.NivelesUsuario;
        //let nivelesPermitidosGPTW = [1,4,5];
        let nivelesPermitidosGPTW = [1,2,,4,5,8,10,12,13,14,17,18,19];
        let nivelesPermitidosGPTW2 = [1,2,,4,5,8,10,11,12,13,14,18];
        if(this.nivelUsuario == 2 ){
          let nivelesCorrectos: any[] = [];
          result.forEach( (lang) => {
            if(nivelesPermitidosGPTW.includes(lang.nivel)){
              nivelesCorrectos.push(lang);
            }
          });
          result = nivelesCorrectos;
        }else if(this.nivelUsuario == 11 ){
          let nivelesCorrectos: any[] = [];
          result.forEach( (lang) => {
            if(nivelesPermitidosGPTW2.includes(lang.nivel)){
              nivelesCorrectos.push(lang);
            }
          });
          result = nivelesCorrectos;
        }
        else if(this.nivelUsuario == 3){
          let nivelesPermitidosITBM = [1,2,3,4,5,8,10,11,12,13,14,17,18,19];
          let nivelesCorrectos3: any[] = [];
          result.forEach( (lang) => {
            if(nivelesPermitidosITBM.includes(lang.nivel)){
              nivelesCorrectos3.push(lang);
            }
          });
          result = nivelesCorrectos3;

        }
        this.levels = result;

        console.log(this.levels);

      }, error => {
        //console.log("error", error);
      })
    }

    // public getEnterprisesArray() {
    //   let datos = {institutoId:this.institutoId};
    //   console.log(datos);
    //   this.odsService.getListaEmpresas(datos,1)
    //   .subscribe(response => {
    //     console.log(response);
    //     let result: Enterprise[] = response['data'];
    //     this.enterprises = result;
    //     this.enterprises.filterPredicate = (data, filterValue: string)  => {
    //       const accumulator = (currentTerm, key) => {
    //         return key === 'datosEmpresa' ? currentTerm + data.datosEmpresa.nombreEmpresa : currentTerm + data[key];
    //       };
    //       const dataStr = Object.keys(data).reduce(accumulator, '').toLowerCase();
    //       // console.log(dataStr);
    //       // Transform the filterValue by converting it to lowercase and removing whitespace.
    //       const transformedFilter = filterValue.trim().toLowerCase();
    //       return dataStr.indexOf(transformedFilter) !== -1;
    //     };
    //
    //     console.log(this.enterprises);
    //
    //
    //   }, error => {
    //     //console.log("error", error);
    //   })
    // }
    applyFilter(filterValue: string) {
      this.enterprises.filter = filterValue.trim().toLowerCase();
      console.log(this.enterprises);



      if (this.enterprises.paginator) {
        this.enterprises.paginator.firstPage();


      }
    }

    getUsuariosEmpresas(respuesta: string,nombre?:string,institutoId?:any){
      localStorage.setItem('instituto_id',institutoId);
      console.log("Respuestas "+respuesta);
      this.idEmpresaBuscar=respuesta;
      this.nombreEmpresaBuscar=nombre;
      console.log("valor", respuesta);
      this.cargando=true;
      this.registerService.getUsuariosEmpresas(respuesta,this.institutoId,1).subscribe((response:any) => {
        this.cargando=false;
        if (response.usuarios.length>0) {
          console.log(response);
          this.dataSource= new MatTableDataSource(response.usuarios);
          console.log('this.dataSource',this.dataSource);

          if (respuesta!=undefined) {
            this.usuariosEncontrados=true;
            setTimeout(() => this.dataSource.paginator = this.paginator);
          }else{
            this.usuariosEncontrados=false;
            console.log("no encontrousuarios");
          }
    }
      }, error => {
        console.log(error);
      })
    }

    getUsuariosEmpresasGptw(pagina:number){
    if(pagina){
    let datos:any = {};
      if(this.respuestagptw.length > 0){
        datos.search = this.respuestagptw
        console.log(datos.search);

      }
      this.registerService.getUsuariosGPTWEmpresas(pagina,this.institutoId,datos).subscribe((response:any) => {
        console.log(response);

        this.dataSourceEmpresaGPTW = response.result.docs;
        this.totalEmpresasEmpresaGPTW = response.result.totalDocs;
        this.nextPagEmpresaGPTW = response.result.nextPage;
        this.prevPagEmpresaGPTW = response.result.prevPage;
        this.contadorInicioEmpresaGPTW = response.result.pagingCounter;
        this.contadorFinEmpresaGPTW = this.contadorInicioEmpresaGPTW + (response.result.limit - 1);
        if(this.contadorFinEmpresaGPTW > this.totalEmpresasEmpresaGPTW){
          this.contadorFinEmpresaGPTW = this.totalEmpresasEmpresaGPTW;
        }
        this.cargando = false;
      }, error => {
        console.log(error);
      })
    }
    }


    openEditarUsuarioEmpresa(idUser:any, user:any,nivel:any, institutoId?:any,nombreEmpresa?:any) {
      localStorage.setItem('idUser',idUser);
      localStorage.setItem('user',user);
      localStorage.setItem('nivel',nivel);

      if (!nombreEmpresa) {
          localStorage.removeItem('nombreEmpresaSelect');
          console.log("Se elimino nombreEmpresaSelect");

      }else{
        console.log("se creo nombreEmpresaSelect");
        localStorage.setItem('nombreEmpresaSelect',nombreEmpresa);

      }

      if(institutoId){
        localStorage.setItem('instituto_id',institutoId);

      }

      console.log(idUser);
      console.log('institutoId',institutoId);
  const dialogRef = this.dialog.open(DialogEditUsuarioEmpresa,{
    height: '80%',
    width: '70%',
    disableClose: true,
  });
  dialogRef.afterClosed().subscribe(result => {
    console.log(`Dialog result: ${result}`);
    console.log(this.idEmpresaBuscar);

    this.getUsuariosEmpresas(this.idEmpresaBuscar);
    this.getUsuariosEmpresasGptw(1);
  });
}


    getListaEmpresas(pagina?:number,tipoAccion?:number){
      console.log(" tipo de accion ", tipoAccion);

      switch(tipoAccion) {
        case 1:
        console.log("entro el Crear Usuario");
        if(pagina){
          let datos:any = {institutoId:this.institutoId,platforms:this.preFilterPlat};
          if(this.busqueda.length > 0){
            datos.search = this.busqueda
          }
          this.odsService.getListaEmpresas(datos,pagina).subscribe( (respuesta:backInter.getListaEmpresas) => {
            console.log(respuesta);
            this.enterprises = respuesta.data.docs;
            this.totalEmpresas = respuesta.data.totalDocs;
            this.nextPag = respuesta.data.nextPage;
            this.prevPag = respuesta.data.prevPage;
            this.contadorInicio = respuesta.data.pagingCounter;
            this.contadorFin = this.contadorInicio + (respuesta.data.limit - 1);
            if(this.contadorFin > this.totalEmpresas){
              this.contadorFin = this.totalEmpresas;
            }
          });
        }

          break;
          case 2:
          console.log("entro el buscar Usuario");

          if(pagina){
            let datos:any = {institutoId:this.institutoId,platforms:this.preFilterPlat};
            if(this.busquedaUsuario.length > 0){
              datos.search = this.busquedaUsuario
            }
            this.odsService.getListaEmpresas(datos,pagina).subscribe( (respuesta:backInter.getListaEmpresas) => {
              console.log(respuesta);

              this.enterprises = respuesta.data.docs;
              this.totalEmpresas = respuesta.data.totalDocs;
              this.nextPag = respuesta.data.nextPage;
              this.prevPag = respuesta.data.prevPage;
              this.contadorInicio = respuesta.data.pagingCounter;
              this.contadorFin = this.contadorInicio + (respuesta.data.limit - 1);
              console.log(this.enterprises);
              if(this.contadorFin > this.totalEmpresas){
                this.contadorFin = this.totalEmpresas;
              }
            });
          }
        break;

        default:
          break;
      }

    }


    deleteUsuarios(idUsuario,nombreUsuario,tipoUsu){
      console.log(tipoUsu);
      console.log(idUsuario);
      console.log(nombreUsuario);
      let mensajeTexto1 = 'PERFILES.USUARIO.CONFIRM_ELIMINAR_USU';
      let btnAceptar = 'MODALES.ACCIONES.aceptar';
      let btnCancelar = 'MODALES.ACCIONES.cancelar';
      this.translateSrv.get(mensajeTexto1).subscribe((res: string) => { mensajeTexto1 = res; });
      this.translateSrv.get(btnAceptar).subscribe((res: string) => { btnAceptar = res; });
      this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
    Swal.fire({
      title: mensajeTexto1,
      icon: 'warning',
      showCancelButton: true,
reverseButtons: true,


      confirmButtonText: btnAceptar,
      cancelButtonText: btnCancelar
    }).then((result) => {
      if (result.value) {
        if (tipoUsu=='Admin') {

        }
        this.codigoValidacionBorrarUsuario(idUsuario,nombreUsuario,tipoUsu);
      }
    });





    }

    codigoValidacionBorrarUsuario(idUsuario,nombreUsuario,tipoUsu){
        let mensajeTexto3 = 'PERFILES.USUARIO.INGR_ELIMINAR_USU';
        let mensajeTexto4 = 'PERFILES.USUARIO.INGR_ELIMINAR_USU.2';
        let btnAceptar = 'MODALES.ACCIONES.aceptar';
        let btnCancelar = 'MODALES.ACCIONES.cancelar';
        let errorUsuario = 'PERFILES.USUARIO.ERROR_ELIMINAR_USU.2';
        let okEliminarUsuario = 'PERFILES.USUARIO.OK_ELIMINAR_USU';
        this.translateSrv.get(mensajeTexto3).subscribe((res: string) => { mensajeTexto3 = res; });
        this.translateSrv.get(mensajeTexto4).subscribe((res: string) => { mensajeTexto4 = res; });
        this.translateSrv.get(btnAceptar).subscribe((res: string) => { btnAceptar = res; });
        this.translateSrv.get(btnCancelar).subscribe((res: string) => { btnCancelar = res; });
        this.translateSrv.get(errorUsuario).subscribe((res: string) => { errorUsuario = res; });
        this.translateSrv.get(okEliminarUsuario).subscribe((res: string) => { okEliminarUsuario = res; });


        // let r = Math.random().toString(36).substring(7);
        // console.log("cadena de datos aleatorios: ",r);

        // let codigo=r;
        Swal.fire({
          title: mensajeTexto3+'<font color="red">'+nombreUsuario+'</font>'+mensajeTexto4,
          icon: 'info',
          input:'text',
          showCancelButton: true,
reverseButtons: true,


          cancelButtonText: btnCancelar,
          confirmButtonText: btnAceptar
        })
        .then( (borrar) => {
          console.log(borrar);
          if (borrar.value==nombreUsuario) {
          this.registerService.deleteUsuarioAdmin(idUsuario).subscribe((response:any) => {
              console.log(response);
              if (tipoUsu=='admin') {
                console.log(' get usuario ADMIN');
                this.getUsuariosEmpresasGptw(1);
              }else{
                console.log(' get Usuario EMPRESA');
                this.getUsuariosEmpresas(this.idEmpresaBuscar);
              }
                this.openSuccessSnackBar(okEliminarUsuario,'OK');

          }, error => {
            console.log(error);
          })


          }
          else{
            if(!borrar.dismiss){
              Swal.fire({
              icon: 'error',
              title: errorUsuario,
              showConfirmButton: true,

              confirmButtonText: 'OK'
              })
            }

          }
        });
      }


      validarPassRegis(event:any){
        const head = document.getElementsByTagName('head')[0];
        let css='';
        this.medirPassRegis=0;
        console.log(event.target.value);
        let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
        let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
        let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
        let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
        let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
        if(event.target.value.length >=10 ){
          this.longitudPassRegis=true;
          this.regalasPassRegis[0].estatus=true;
        }else{
          this.longitudPassRegis=false;
          this.regalasPassRegis[0].estatus=false;
        }

        if(regexMin.test(event.target.value)){
          this.letraMinPassRegis=true;
          this.regalasPassRegis[1].estatus=true;
        }else{
          this.letraMinPassRegis=false;
          this.regalasPassRegis[1].estatus=false;
        }

        if(regexMay.test(event.target.value)){
          this.letraMayuPassRegis=true;
          this.regalasPassRegis[2].estatus=true;
        }else{
          this.letraMayuPassRegis=false;
          this.regalasPassRegis[2].estatus=false;
        }

        if(regexNum.test(event.target.value)){
          this.numePassRegis=true;
          this.regalasPassRegis[3].estatus=true;
        }else{
          this.numePassRegis=false;
          this.regalasPassRegis[3].estatus=false;
        }

        if(regexCharEsp.test(event.target.value)){
          this.caracterPassRegis=true;
          this.regalasPassRegis[4].estatus=true;
        }else{
          this.caracterPassRegis=false;
          this.regalasPassRegis[4].estatus=false;
        }


        console.log('regalasPass',this.regalasPassRegis);
        this.arregloReglasCumplidasRegis=[];

   this.regalasPassRegis.forEach(estatus => {
     if (estatus.estatus==true) {
       this.arregloReglasCumplidasRegis.push(estatus);
     }
   });

   console.log('arregloReglasCumplidasRegis',this.arregloReglasCumplidasRegis);
   if (this.arregloReglasCumplidasRegis.length==1) {
     this.medirPassRegis=10;
     css = css+`
     .valorRegis .mat-progress-bar-fill::after {
       background-color: #cc0000 !important;
     }`;

   }else if (this.arregloReglasCumplidasRegis.length==2) {
     this.medirPassRegis=30;
     css = css+`
     .valorRegis .mat-progress-bar-fill::after {
       background-color: #cc0000 !important;
     }`;

   }else if (this.arregloReglasCumplidasRegis.length==3) {
     this.medirPassRegis=50;
     css = css+`
     .valorRegis .mat-progress-bar-fill::after {
       background-color: #F1EB2B !important;
     }`;

   }else if (this.arregloReglasCumplidasRegis.length==4) {
     this.medirPassRegis=70;
     css = css+`
     .valorRegis .mat-progress-bar-fill::after {
       background-color: #F19C2B !important;
     }`;

   }else if (this.arregloReglasCumplidasRegis.length==5) {
     this.medirPassRegis=100;
     css = css+`
     .valorRegis .mat-progress-bar-fill::after {
       background-color: #46761D !important;
     }`;

   }
   if (this.medirPassRegis==100) {
     this.passwordOkRegis=true;
   }

   this.styleElementRegis.innerHTML = '';
   this.styleElementRegis.type = 'text/css';
   this.styleElementRegis.appendChild(document.createTextNode(css));
   head.appendChild(this.styleElementRegis);

      }

      applyFilterUserCompany(filterValue: string) {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      console.log('this.dataSource.filter',this.dataSource.filter);

      }



  }

  export interface Institute {
    numInstituto: number;
    regionInstituto: string;
  }

  export interface Level {
    nivel: number;
    nombreNivel: string;
  }

  export interface Enterprise {
    id: string;
    nombreEmpresa: string;
  }

  @Component({
    selector: 'editUsuario',
    templateUrl: 'editUsuario.html',
    styleUrls: ['./editUsuario.component.scss'],
  })

  export class DialogEditUsuarioEmpresa {
  // @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger;
   usuario=localStorage.getItem('user');
   idUsuario=localStorage.getItem('idUser');
   nivel=parseInt(localStorage.getItem('nivel'));
   @Output() updatedatos: EventEmitter<boolean> = new EventEmitter();
   institutoIdUpdate=parseInt(localStorage.getItem('Idinstituto'));
   password: string = "";
   nivelUsuarioEdit: number;
   levelsEdit: any;
   nivelDefault:any;
   busquedaEmpresa:string="";
   selectedEnterpriseBusU: string;
   enterprises: any;
   institutes : any;
   institutoId: number;
   mostrarSelecInstituto:boolean=false;
   mostrarSelecEmpresa:boolean=false;
   empresaId:any="";
   instituto:any;
   instutoBD:any= localStorage.getItem('instituto_id');
   medirPass:number=0;
   longitudPass:boolean=false;
   regalasPass:any[]=[
     {
       'regla': 'longitud',
        'estatus': false,
   },
     {
       'regla': 'letraMin',
        'estatus': false,
   },
     {
       'regla': 'letraMayu',
        'estatus': false,
   },
     {
       'regla': 'numeroPass',
        'estatus': false,
   },
     {
       'regla': 'caracterPass',
        'estatus': false,
   },
 ]
   letraMinPass:boolean=false;
   letraMayuPass:boolean=false;
   numePass:boolean=false;
   caracterPass:boolean=false;
   arregloReglasCumplidas:any[]=[];
   styleElement: HTMLStyleElement;
   passwordOk:boolean=false;
   versTextLevelResultV2='';
   versDefaultLevelResultV2="1";
   versDisabledTextLevelResultV2:boolean=true;
   preFilterPlat:any[]=[{"datosEmpresa.platform": 1},{"datosEmpresa.platform": 2},{"datosEmpresa.platform": 3}];
    constructor(
      public dialogActualizar: MatDialogRef<DialogEditUsuarioEmpresa>,
      private _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private translateSrv: TranslateService,
      public authService: AuthService,
      private registerServices: RegisterService,
      private odsService: ODSService,
    ){
      let infoUsuEdit: backInter.infoUsuario = this.authService.getInfoUsuario();
      this.nivelUsuarioEdit = infoUsuEdit.level;
      if(infoUsuEdit.level == 3){
        this.institutoId = 0;
        console.log("hola chempo: ",this.institutoId);
      }
      else{
        this.institutoId = infoUsuEdit.institutoId;
        console.log("hola chempo: ",this.institutoId);

      }
      localStorage.setItem('Idinstituto',this.institutoId.toString());
      if (localStorage.getItem('nombreEmpresaSelect')) {
        // this.selectedEnterpriseBusU=localStorage.getItem('nombreEmpresaSelect');
        this.busquedaEmpresa=localStorage.getItem('nombreEmpresaSelect');
        console.log('this.busquedaEmpresa',this.selectedEnterpriseBusU);
      }else{
        // this.selectedEnterpriseBusU="";
        this.busquedaEmpresa="";
        // console.log('this.busquedaEmpresa',this.selectedEnterpriseBusU);
      }

      if (this.nivel==2||this.nivel==3||this.nivel==11) {
        this.selectedEnterpriseBusU="0";
      }

    }
    ngOnInit() {
      console.log('nivel usuario select',localStorage.getItem('nivel'));

      this.instituto=parseInt(localStorage.getItem('instituto_id'));
      console.log(this.instituto);

      this.getLevelArrayEdit();
      this.getListaEmpresas(1,2);
      this.getInstituteArray();
      this.styleElement = document.createElement('style');
    }

    updateUsuario(usuario:any,password:any,nivel:any,selectedEnterpriseBusU:any,instituto:any){
       console.log('selectedEnterpriseBusU',selectedEnterpriseBusU);
       console.log('instituto',instituto);
       console.log('nivel',nivel);
       let empresaId:any;
       if (nivel==3) {
         empresaId=0;
       }else if (nivel==2) {
         empresaId=0;
       }else if (nivel==11) {
         empresaId=0;
       }else {
         empresaId=selectedEnterpriseBusU;
       }

       let instituto_tmp = localStorage.getItem('instituto_id');
       let datos={
         level:nivel,
         institutoId:this.instutoBD,
         user:usuario,
         password:password,
         empresaId:empresaId,
         defaultPlt:this.versDefaultLevelResultV2=="2"? false:true,
         versionPlt:this.versTextLevelResultV2,

       }
       if (nivel==19 && this.versDefaultLevelResultV2=="2" && this.versTextLevelResultV2=="") {
         this.translateSrv.get('CONSULTATABLA.TEX_MOD_RESULT_VERS').subscribe((res: string) => {
             this.openSnackBar(res,this.translateSrv.instant('ALERTS.OK'));
           });
       }else{
         console.log(datos);
         let texto = 'PERFILES.USUARIO.UPDATE-USER';
         let textoUserExist = 'PERFILES.USUARIO.EXIST-USER';
         let rspSi = 'MODALES.ACCIONES.aceptar';
         let textoALERT = 'PERFILES.USUARIO.ALERT-EDIT';
         let rspCancelar = 'MODALES.ACCIONES.cancelar';
         this.translateSrv.get(texto).subscribe((res: string) => { texto = res; });
         this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
         this.translateSrv.get(textoUserExist).subscribe((res: string) => { textoUserExist = res; });
         this.translateSrv.get(textoALERT).subscribe((res: string) => { textoALERT = res; });
         this.translateSrv.get(rspCancelar).subscribe((res: string) => { rspCancelar = res; });
         Swal.fire({
           title: textoALERT,
           icon: 'warning',
           showCancelButton: true,
           reverseButtons: true,


           confirmButtonText: rspSi,
           cancelButtonText: rspCancelar,
         }).then((result) => {
           if (result.value) {
             console.log("dijo que si :)");
             this.registerServices.actualizaUsuariosEmpresas(this.idUsuario,datos).subscribe((response:any) => {
                 console.log(response);
                 if(response.message=="200"){
                   Swal.fire({
                       icon: 'success',
                       title: texto,
                       confirmButtonText: rspSi,
                       confirmButtonColor: '#e40601'
                     });
                     this.onClose();
                     this.updatedatos.emit(true);

                   }else if(response.message=="userAlreadyExist"){
                       Swal.fire({
                           icon: 'warning',
                           title: textoUserExist,
                           confirmButtonText: rspSi,
                           confirmButtonColor: '#e40601'
                         });
                         this.onClose();
                       }

                       }, error => {
                           console.log(error);
                         })
                       }else{
                         console.log("dijo que no :(");
                         // this.onClose();
                       }
                     });

       }

    }

    onClose(): void {
        this.dialogActualizar.close();
      }


       getLevelArrayEdit() {
        this.registerServices.getLevel().subscribe((response:any) => {
          console.log("Niveles");
          console.log(response);
          let result: Level[] = response.NivelesUsuario;
          //let nivelesPermitidosGPTW = [1,4,5];
          let nivelesPermitidosGPTW = [1,2,,4,5,8,10,11,12,13,14,18,19];
          console.log("el usuario es: ",this.nivelUsuarioEdit);
          if(this.nivelUsuarioEdit == 2 || this.nivelUsuarioEdit == 11){

            let nivelesCorrectos: any[] = [];
            result.forEach( (lang) => {
              // console.log(lang.nivel);
              if(nivelesPermitidosGPTW.includes(lang.nivel)){
                nivelesCorrectos.push(lang);
              }
                if(lang.nivel==this.nivel){
                  this.nivelDefault=lang.nivel;
                    }
            });
            result = nivelesCorrectos;
          }else if(this.nivelUsuarioEdit == 3){
            let nivelesPermitidosITBM = [];
            if (localStorage.getItem('nivel')=="15") {
              nivelesPermitidosITBM = [15];

            }else{
              nivelesPermitidosITBM = [1,2,3,4,5,8,10,11,12,13,14,18,19];
            }
            let nivelesCorrectos3: any[] = [];
            result.forEach( (lang) => {
              // console.log(lang.nivel);
              if(nivelesPermitidosITBM.includes(lang.nivel)){
                nivelesCorrectos3.push(lang);
              }
              if(lang.nivel==this.nivel){
                this.nivelDefault=lang.nivel;
                // console.log(this.nivelDefault);

              }
            });
            result = nivelesCorrectos3;

          }
          this.levelsEdit = result;

          // console.log(this.levelsEdit);

        }, error => {
          //console.log("error", error);
        })
      }



      getListaEmpresas(pagina?:number,tipoAccion?:number){
        switch(tipoAccion) {
            case 2:
            if(pagina){
              let datos:any = {institutoId:this.institutoId,platforms:this.preFilterPlat};
              if(this.busquedaEmpresa.length > 0){
                datos.search = this.busquedaEmpresa
              }
              this.odsService.getListaEmpresas(datos,pagina).subscribe( (respuesta:backInter.getListaEmpresas) => {
                console.log(respuesta);
                this.enterprises = respuesta.data.docs;
              });
            }
          break;

          default:
            break;
        }

      }

      public getInstituteArray() {
        this.odsService.getInstituteArray()
        .subscribe(response => {
          console.log(response);
          let result: Institute[] = response['Institutos'];
          this.institutes = result;
          this.validarInstitutos();
        }, error => {
          console.log("error", error);
        })
      }

      validarInstitutos(){
        if(this.nivelUsuarioEdit == 2 || this.nivelUsuarioEdit == 11 ){
          let institutoCorrecto: any[] = [];
          this.institutes.forEach( (instituto) => {
            if(instituto.numInstituto == this.institutoId ){
              institutoCorrecto.push(instituto);
            }
          });
          console.log(institutoCorrecto);
          this.institutes=institutoCorrecto;

        }

      }

      institutoEmpresa(instituto){
        console.log(instituto);

        this.instutoBD=instituto;
        console.log('this.instutoBD',this.instutoBD);
      }

      institutoEmpresaElegido(instituto){
        console.log(instituto);

        this.instutoBD=instituto;
        console.log('this.instutoBD',this.instutoBD);
      }

      selectNivelUse(level){
        console.log('level',level);
        if (level==2 || level==11) {
          this.instutoBD=localStorage.getItem('instituto_id');
          this.selectedEnterpriseBusU="0";
        }else if (level==3) {
          this.instutoBD='0';
        }
        console.log('this.instutoBD',this.instutoBD);

      }

      validarPass(event:any){
        const head = document.getElementsByTagName('head')[0];
        let css='';
        this.medirPass=0;
        console.log(event.target.value);
        let regexPass = new RegExp("^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*([_]|[ -\/]|[:-\@]|[[-\`]|[{-\■])).{8,64}$");
        let regexMin = new RegExp("^(?=.*[a-z]).{1,64}$");
        let regexMay = new RegExp("^(?=.*[A-Z]).{1,64}$");
        let regexNum = new RegExp("^(?=.*[0-9]).{1,64}$");
        let regexCharEsp = new RegExp("[_]|[ -\/]|[:-\@]|[[-\`]|[{-\■]");
        if(event.target.value.length > 7){
          this.longitudPass=true;
          this.regalasPass[0].estatus=true;
        }else{
          this.longitudPass=false;
          this.regalasPass[0].estatus=false;
        }

        if(regexMin.test(event.target.value)){
          this.letraMinPass=true;
          this.regalasPass[1].estatus=true;
        }else{
          this.letraMinPass=false;
          this.regalasPass[1].estatus=false;
        }

        if(regexMay.test(event.target.value)){
          this.letraMayuPass=true;
          this.regalasPass[2].estatus=true;
        }else{
          this.letraMayuPass=false;
          this.regalasPass[2].estatus=false;
        }

        if(regexNum.test(event.target.value)){
          this.numePass=true;
          this.regalasPass[3].estatus=true;
        }else{
          this.numePass=false;
          this.regalasPass[3].estatus=false;
        }

        if(regexCharEsp.test(event.target.value)){
          this.caracterPass=true;
          this.regalasPass[4].estatus=true;
        }else{
          this.caracterPass=false;
          this.regalasPass[4].estatus=false;
        }


        console.log('regalasPass',this.regalasPass);
        this.arregloReglasCumplidas=[];

   this.regalasPass.forEach(estatus => {
     if (estatus.estatus==true) {
       this.arregloReglasCumplidas.push(estatus);
     }
   });

   console.log('arregloReglasCumplidas',this.arregloReglasCumplidas);
   if (this.arregloReglasCumplidas.length==1) {
     this.medirPass=10;
     css = css+`
     .valor .mat-progress-bar-fill::after {
       background-color: #cc0000 !important;
     }`;

   }else if (this.arregloReglasCumplidas.length==2) {
     this.medirPass=30;
     css = css+`
     .valor .mat-progress-bar-fill::after {
       background-color: #cc0000 !important;
     }`;

   }else if (this.arregloReglasCumplidas.length==3) {
     this.medirPass=50;
     css = css+`
     .valor .mat-progress-bar-fill::after {
       background-color: #F1EB2B !important;
     }`;

   }else if (this.arregloReglasCumplidas.length==4) {
     this.medirPass=70;
     css = css+`
     .valor .mat-progress-bar-fill::after {
       background-color: #F19C2B !important;
     }`;

   }else if (this.arregloReglasCumplidas.length==5) {
     this.medirPass=100;
     css = css+`
     .valor .mat-progress-bar-fill::after {
       background-color: #46761D !important;
     }`;

   }
   if (this.medirPass==100) {
     this.passwordOk=true;
   }

   this.styleElement.innerHTML = '';
   this.styleElement.type = 'text/css';
   this.styleElement.appendChild(document.createTextNode(css));
   head.appendChild(this.styleElement);

      }

      cambiarVersionUpdUser(value){
        console.log(value);

      if (value==2) {
        this.versDisabledTextLevelResultV2=false;
      }else{
        this.versDisabledTextLevelResultV2=true;
        this.versTextLevelResultV2="";
      }

      }

      openSnackBar(message: string, action: string) {
        Swal.fire({
          icon: 'error',
          title: message,
          confirmButtonText: action,
          confirmButtonColor: '#e40601'
        });
      }


  }
